
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-production/explainer-videos",
      function () {
        return require("private-next-pages/video-production/explainer-videos/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-production/explainer-videos"])
      });
    }
  